import { createI18n } from "vue-i18n";

export function createI18nVueModule() {
    let i18n = null;

    if (window) {
        // if no non-english locale specified, return English i18n object
        if (!window.pcI18nLocale) {
            const messages = { en: window.pcI18nDefault };
            i18n = createI18n({
                locale: "en",
                messages
            });
            return i18n;
        }

        // handle other languages, need to change to locale (es ==> es-ES) be
        let messages = null;
        let locale = null;
        switch (window.pcI18nLocale) {
            case "es":
                locale = "es";
                messages = {
                    en: window.pcI18nDefault,
                    es: window.pcI18nMessages
                };
                break;
            case "de":
                locale = "de"; // For Robert and Torsten to check out.
                messages = {
                    en: window.pcI18nDefault,
                    de: window.pcI18nMessages
                };
                break;
            case "fr":
                locale = "fr";
                messages = {
                    en: window.pcI18nDefault,
                    fr: window.pcI18nMessages
                };
                break;
            case "en_ca":
                locale = "en-CA";
                messages = {
                    "en-CA": window.pcI18nMessages,
                    en: window.pcI18nDefault
                };
                break;
            case "gib":
                locale = "gib";
                messages = {
                    gib: window.pcI18nMessages
                };
                break;
            default:
                locale = "en";
                messages = {
                    en: window.pcI18nDefault
                }; // force default to English for unsupported languages
        }

        i18n = createI18n({
            locale: locale,
            fallbackLocale: "en", // default locale will always be English
            silentFallbackWarn: true,
            formatFallbackMessages: true,
            silentTranslationWarn: true, // suppresses warnings for missing translations in selected locale
            messages
        });

        return i18n;
    }
}
